export default __webpack_public_path__ + "static/coin-84e71467a5c773ba2b8647384fddb543.png";